import { Input, InputBaseProps, OutlinedInput } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

interface InputProps extends InputBaseProps {
  type?: string;
  debounce?: boolean;
  isOutlined?: boolean;
  label?: string;
}

const InputField = ({ type, debounce, onChange, value, isOutlined, label, inputProps, ...rest }: InputProps) => {
  const [localValue, setLocalValue] = useState(value);
  const minValue = inputProps?.min;

  const debounced = useDebouncedCallback((e: any) => {
    if (onChange) {
      onChange(e);
    }
  }, 600);

  const handleOnchange = (e: any) => {
    let newValue = e;

    // For number inputs with min, enforce minimum value
    if (type === 'number' && minValue !== undefined) {
      const numValue = Number(newValue);
      if (!isNaN(numValue) && numValue < minValue) {
        newValue = String(minValue);
      }
    }

    const callback = debounce ? debounced : onChange;
    setLocalValue(newValue);
    if (callback) {
      callback(newValue);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    // Prevent minus sign for inputs with min >= 0
    if (type === 'number' && minValue !== undefined && minValue >= 0 && e.key === '-') {
      e.preventDefault();
    }
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <>
      {isOutlined ? (
        <OutlinedInput
          type={type}
          value={debounce ? localValue : value}
          label={label}
          fullWidth
          onChange={(data: any) => handleOnchange(data.target.value)}
          onKeyDown={handleKeyDown}
          inputProps={inputProps}
          {...rest}
        />
      ) : (
        <Input
          type={type}
          value={debounce ? localValue : value}
          fullWidth
          disableUnderline
          onChange={(data: any) => handleOnchange(data.target.value)}
          onKeyDown={handleKeyDown}
          inputProps={inputProps}
          {...rest}
        />
      )}
    </>
  );
};

export default InputField;
